export const COLORS = ['#8A73D8', '#94DAFB', '#68D3CD', '#FF8042', '#CFF67C', '#F5BC41', '#F2AFB0', '#9D9D9D'];
export const MAIN_COLORS = ['#28BF8D', '#F6B86E', '#BA82BA', '#26BDF0', '#F0D76C', '#EB7D86'];
